import { render, staticRenderFns } from "./EqsBadge.vue?vue&type=template&id=cf0c073a"
import script from "./EqsBadge.vue?vue&type=script&lang=js"
export * from "./EqsBadge.vue?vue&type=script&lang=js"
import style0 from "./EqsBadge.vue?vue&type=style&index=0&id=cf0c073a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports